import { useState } from 'react'
import { DamageAct } from './DamageAct'
import { Badge } from 'shared/components/ui/badge'
import { Button } from 'shared/components/ui/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from 'shared/components/ui/dialog'
import { useTranslate } from 'shared/lib/i18n'

/**
 * «Повреждена» for the Parcel just answered — scanned at the hub, a return just accepted
 * at the Point (ticket 42): a button at the answer's top right opens the act in a
 * dialog; once recorded the dialog closes, the button turns into «повреждение
 * отмечено». However the dialog closes, the scan field takes the cursor back
 * (`onClosed`) — the next scan must not land on a button.
 */
export function DamageDialog({
	parcelId,
	code,
	testId,
	onClosed,
}: {
	parcelId: string
	code: string
	/** The button's `data-testid`. */
	testId: string
	onClosed?: () => void
}) {
	const { t } = useTranslate()
	const [open, setOpen] = useState(false)
	const [recorded, setRecorded] = useState(false)

	if (recorded) {
		return (
			<Badge
				variant='outline'
				className='border-amber-500/60 bg-background text-amber-700 dark:text-amber-400'
				data-testid='damage-recorded'
			>
				{t('damage.recorded')}
			</Badge>
		)
	}

	return (
		<Dialog
			open={open}
			onOpenChange={(next) => {
				setOpen(next)
				if (!next) onClosed?.()
			}}
		>
			<DialogTrigger asChild>
				<Button variant='outline' size='sm' className='bg-background' data-testid={testId}>
					{t('damage.open')}
				</Button>
			</DialogTrigger>
			<DialogContent
				className='sm:max-w-md'
				aria-describedby={undefined}
				onCloseAutoFocus={(event) => event.preventDefault()}
			>
				<DialogHeader>
					<DialogTitle>{t('damage.title', { code })}</DialogTitle>
				</DialogHeader>
				<DamageAct
					bare
					parcelId={parcelId}
					code={code}
					onCancel={() => {
						setOpen(false)
						onClosed?.()
					}}
					onDone={() => {
						setRecorded(true)
						setOpen(false)
						onClosed?.()
					}}
				/>
			</DialogContent>
		</Dialog>
	)
}
